
import React from 'react'


const MiniWebpage = ({ id, elements }) => {
    return (
        <div className='w-full h-full'>

        </div>
    )
}

export default MiniWebpage